


































import { BDMAssessment } from '@core/model/recruit/forms/BDMAssessment'
import { RecruitManagerAssessment } from '@core/model/recruit/forms/RecruitManagerAssessment'
import RecruitDetails from '@core/model/recruit/RecruitDetail'
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const recruitFormStore = namespace('RecruitFormStore')

@Component
export default class RecruitFormsNavi extends Vue {
  @recruitFormStore.State
  private forms

  @recruitFormStore.Getter
  private createdForms

  @recruitFormStore.State
  private recruitDetails: RecruitDetails

  get allowedForms () {
    return this.createdForms.filter(form => {
      const recruitCantSee = [RecruitManagerAssessment, BDMAssessment].includes(form.model) && this.recruitDetails.isCurrentRecruit
      return !recruitCantSee
    })
  }

  get parentPath () {
    const path = this.$router.currentRoute.matched[0].path
    const param = this.$router.currentRoute.params.recruitAccountOid
    return path.replace(':recruitAccountOid', param)
  }

  setIndicate (sec) {
    this.$emit('indicate', sec)
  }

  mounted () {
    this.focusCurMenu()
  }

  // this will reattempt indefinitely
  focusCurMenu () {
    setTimeout(() => {
      const curFormName = this.$router.currentRoute.name
      if (!curFormName) return this.focusCurMenu()
      const formMenu = document.getElementById(`menu-${curFormName}`)
      if (!formMenu) return this.focusCurMenu()
      formMenu.scrollIntoView({ behavior: 'smooth' })
    }, 100)
  }
}
